/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} No_Book_Projects_YetInputs */

const en_no_book_projects_yet = /** @type {(inputs: No_Book_Projects_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No book projects yet.`)
};

const es_no_book_projects_yet = /** @type {(inputs: No_Book_Projects_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aún no hay proyectos de libros.`)
};

const fr_no_book_projects_yet = /** @type {(inputs: No_Book_Projects_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun projet de livre pour le moment.`)
};

const de_no_book_projects_yet = /** @type {(inputs: No_Book_Projects_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine Buchprojekte.`)
};

const ja_no_book_projects_yet = /** @type {(inputs: No_Book_Projects_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`まだブックプロジェクトはありません。`)
};

const zh_no_book_projects_yet = /** @type {(inputs: No_Book_Projects_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暂无图书项目。`)
};

const ar_no_book_projects_yet = /** @type {(inputs: No_Book_Projects_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا توجد مشاريع كتب بعد.`)
};

const id_no_book_projects_yet = /** @type {(inputs: No_Book_Projects_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum ada proyek buku.`)
};

const it_no_book_projects_yet = /** @type {(inputs: No_Book_Projects_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ancora nessun progetto libro.`)
};

const ru_no_book_projects_yet = /** @type {(inputs: No_Book_Projects_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пока нет проектов книг.`)
};

const pt_no_book_projects_yet = /** @type {(inputs: No_Book_Projects_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sem projetos de livros ainda.`)
};

const ko_no_book_projects_yet = /** @type {(inputs: No_Book_Projects_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`아직 책 프로젝트가 없습니다.`)
};

/**
* | output |
* | --- |
* | "No book projects yet." |
*
* @param {No_Book_Projects_YetInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const no_book_projects_yet = /** @type {((inputs?: No_Book_Projects_YetInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_Book_Projects_YetInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_no_book_projects_yet(inputs)
	if (locale === "es") return es_no_book_projects_yet(inputs)
	if (locale === "fr") return fr_no_book_projects_yet(inputs)
	if (locale === "de") return de_no_book_projects_yet(inputs)
	if (locale === "ja") return ja_no_book_projects_yet(inputs)
	if (locale === "zh") return zh_no_book_projects_yet(inputs)
	if (locale === "ar") return ar_no_book_projects_yet(inputs)
	if (locale === "id") return id_no_book_projects_yet(inputs)
	if (locale === "it") return it_no_book_projects_yet(inputs)
	if (locale === "ru") return ru_no_book_projects_yet(inputs)
	if (locale === "pt") return pt_no_book_projects_yet(inputs)
	return ko_no_book_projects_yet(inputs)
});